<template>
  <div class="main-content">
    <div :class="{'is-open': isLeftSidebarVisible}" class="mailbox">
      <div class="mailbox-sidebar">
        <button type="button" @click="getRecords(false)" class="btn btn-theme btn-sm btn-block">Обновить
          ({{ (showArchive ? archiveCahts : chats).length }})
        </button>
        <button type="button" @click="showArchive = !showArchive"
                :class="{'btn btn-outline-primary btn-sm btn-block mt-1 mb-1': true, 'active': showArchive}">
          {{ showArchive ? 'Активные чаты' : 'Архив' }}
        </button>
        <div v-if="showArchive" class="mb-1">
          <DateSelect
            ref="selectedDate"
            :disabled="false"
            format="DD.MM.YYYY"
            :disabledBefore="archiveDateDisabledBefore"
            :onSelect="date => updateSelectedDate(date)"
            :selectedDate="selectedDate"
          />
        </div>
        <div class="ul_block">
          <ul class="sidebar-menu mt-0">
            <li v-for="(c, i) in (showArchive ? archiveCahts : chats)"
                v-bind:class="{'pointer border-bottom': true,'active': selectedChat?.id === c.id}">
              <div @click="openChat(c)">
                <template v-if="c.bot.type === 2">
                  <p><span class="badge badge-primary">Оплата StreamPay/CoinCat</span></p>
                </template>
                <p>{{ $AllProjects && $AllProjects[c.bot.project_id]?.title }} <span
                  :class="{
                  badge:true,
                  'badge-telegram':c.bot.platform === 'telegram',
                  'badge-whatsapp':c.bot.platform === 'whatsapp',
                  'badge-jivo':c.bot.platform === 'jivo',
                  'badge-viber':c.bot.platform === 'viber',
                }">{{ c.bot.platform }}</span> <span
                  v-if="c.hasNewMessages"
                  class="badge badge-success">new</span></p>
                <p><strong>{{ c?.client?.client_data?.name || 'Без имени' }}</strong></p>
                <p class="fs-10" v-if="c.bot.platform === 'whatsapp'">{{ c.client.chat_id }}</p>
                <p class="fs-10" v-if="c.bot.platform === 'telegram'">{{ c.client.client_data?.username }}</p>
                <p class="text-muted">{{ printDate(c?.last_message?.created_at) }} ({{ c.id }})
                  <StatusChange v-if="showArchive" :dialog="c" :showOnly="true"/>
                </p>
              </div>
              <div class="black_list_btn" v-if="c.client?.phone?.black_list">
                <BlackListButton
                  :phone="c.client.phone"
                  :blackList="c.client.phone.black_list"
                />
              </div>
            </li>
          </ul>
        </div>
        <a class="left-sidebar-btn" @click="isLeftSidebarVisible = !isLeftSidebarVisible">
          <i v-show="!isLeftSidebarVisible" class="icon-fa icon-fa-angle-right"/>
          <i v-show="isLeftSidebarVisible" class="icon-fa icon-fa-angle-left"/>
        </a>

      </div>
      <div class="mailbox-content">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-5"/>
        <!--        <div v-if="!loading && selectedChat">-->
        <!--          <div v-if="!displayTasks || !displayTasks.length" class="alert alert-info m-2 text-center">-->
        <!--            <p>Активных задач не найдено</p>-->
        <!--          </div>-->
        <div class="wrapCollapse">
          <pulse-loader :loading="messagesLoading" :color="$constants.LOADING_COLOR" class="text-center mt-5"/>
          <template v-if="!messagesLoading">
            <template v-if="chatToDisplay">
              <div v-if="warningProjects.includes(selectedChat?.bot?.project_id)"
                   class="alert alert-danger mr-2 mt-2 mb-2 ml-0">
                <strong>Осторожно, обращение со справочной!!!</strong>
                <div>{{ warningText }}</div>
                <div class="text-right">
                  <button class="btn btn-default" @click="message = warningText">Добавить в чат</button>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-md-7 p-1">
                  <div class="messages_block mr-2">
                    <ChatMessages
                      :loadedImages="loadedImages"
                      :updateLoadedImages="(i) => loadedImages = i"
                      :messages="chatToDisplay.messages"/>
                  </div>
                  <div class="mt-1 mb-1 mr-2">
                    <form @submit.prevent="() => sendMessage('message')">
                      <div class="input-group">
                        <!--                    <textarea :disabled="sendLoading" v-model="message" required class="form-control br-0" rows="2"/>-->
                        <input type="text" :disabled="sendLoading" v-model="message" required class="form-control br-0"
                               placeholder="Сообщение">
                        <div class="input-group-append">
                          <LoadingButton
                            title="Отправить"
                            type="submit"
                            :loading="sendLoading"
                            :color="$constants.LOADING_COLOR"
                            :onClick="() => {}"
                            className="btn btn-outline-info br-0"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-5 p-1 pt-2">
                  <div class="card">
                    <div class="card-body p-1">
                      <DrugSearchNew ref="searchDrug" :onSelect="(d) => searchDataForDrug(d)" :showOptions="true"/>

                      <div class="mt-1">
                        <label>Выберите город доставки</label>
                        <select v-model="selectedCityId" class="form-control">
                          <option value="0">Почтовая доставка</option>
                          <option v-for="c in sortArray($AllCities, 'name')" :value="c.id">{{ c.name }}</option>
                        </select>
                      </div>
                      <div v-if="drugForStoreData">
                        <ChatStoreStatus :selectedCityId="selectedCityId"
                                         :projectId="selectedChat.locality.project_id"
                                         :drug="drugForStoreData"
                                         :addDrugToOrder="(drug) => $refs.newOrderBlock.updateDrugData(drug, 0)"
                                         :sendDrugMessage="(drug) => sendMessage('drug', drug)"/>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body p-1">
                      <DeliveryStatus v-if="selectedChat" ref="deliveryStatus" :selectedChat="selectedChat"
                                      :projectId="selectedChat.locality.project_id"/>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body p-1">
                      <StatusChange :dialog="chatToDisplay"
                                    :cityId="selectedCityId"
                                    :drug="$refs.searchDrug?.drug"
                                    :onUpdate="() => getRecords(false)"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-1">
                <ChatReplySnippets :hideManage="true" :onSelect="(m) => message = m"/>
              </div>

              <div class="new_order_from_bot_block mt-2 mr-2">

                <div class="card" v-if="chatToDisplay?.orders.length">
                  <div class="card-header">
                    <h5>Заявки клиента</h5>
                  </div>
                  <div class="card-body">
                    <div v-for="o in getSortedOrders()" class="mb-1">
                      ({{ o.project_label }}) <strong>{{ o.id }}</strong>
                      <span v-html="printOrderStatus(o)"/>
                      <button
                        @click="openOrderInModal(o.id)"
                        class="btn btn-xs btn-info ml-1"
                      >
                        <i class="icon-fa icon-fa-eye"></i>
                      </button>
                      <button
                        @click="loadNewOrder(o.id)"
                        class="btn btn-xs btn-outline-success ml-1"
                      >показать заявку тут
                      </button>
                    </div>
                  </div>
                </div>

                <template v-if="selectedChat?.order_id">
                  <EditOrder
                    ref="newOrderBlock"
                    :orderId="selectedChat.order_id"
                    :sendDrugMessage="(drug) => sendMessage('drug', drug)"
                  />
                </template>
                <template v-else>
                  <NewOrder
                    ref="newOrderBlock"
                    :sendDrugMessage="(drug) => sendMessage('drug', drug)"
                    :extraOptions="{
                      chatBotDialogId: selectedChat?.id,
                      savePreOrder: true,
                      disable: {
                        projectSelect: true,
                      },
                      hide: {
                        newOrderHeader: true
                      }
                    }"
                  />
                </template>

              </div>

              <div class="mt-3 mr-2 flex justify-content-between">
                <LoadingButton
                  title="Отправить диалог в архив"
                  type="button"
                  :loading="sendLoading"
                  :color="$constants.WARNING_COLOR"
                  :onClick="() => closeDialog()"
                  className="btn btn-outline-warning br-0"
                />
                <LoadingButton
                  title="Отправить заказ в чат"
                  type="button"
                  :loading="sendLoading"
                  :color="$constants.PRIMARY_COLOR"
                  :onClick="() => sendMessage('offer')"
                  className="btn btn-outline-info br-0 mr-2"
                />
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!--    </div>-->
  </div>
</template>

<script>

import api from "@/api";
import ChatMessages from "@/views/customersRequests/components/ChatMessages.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import {chatUpdated, fillOrderBus} from "@/eventsBus";
import NewSmallOrder from "@/views/customersRequests/components/NewSmallOrder.vue";
import NewOrder from "@/views/orders/New2.vue"
import EditOrder from "@/views/orders/Edit2.vue"
import DateSelect from "@/views/reports/components/OrderDateSelect.vue"
import moment from "moment/moment";
import BlackListButton from "@/components/clients/BlackListButton.vue";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import ChatStoreStatus from "@/components/drugs/ChatStoreStatus.vue";
import DeliveryStatus from "@/components/orders/ordersData/DeliveryStatus.vue";
import StatusChange from "@/views/customersRequests/components/StatusChange.vue";
import ChatReplySnippets from "@/views/customersRequests/components/ChatReplySnippets.vue";

export default {
  title: 'Чаты с клиентами',
  components: {
    ChatReplySnippets,
    StatusChange,
    DeliveryStatus,
    ChatStoreStatus,
    DrugSearchNew,
    NewSmallOrder,
    ChatMessages,
    LoadingButton,
    NewOrder,
    EditOrder,
    DateSelect,
    BlackListButton,
  },
  data() {
    return {
      drugForStoreData: null,
      selectedCityId: 1,
      selectedText: {
        type: 'drug',
        value: null
      },
      warningProjects: [7, 12],
      warningText: 'Добрый день! \n' +
        'Я вижу что к сожалению этот препарат на данный момент у нас закончился, но я вижу в системе, что он есть в "партнёрской аптеке Фарм-доставка". У них он по этой же цене, и доступен к заказу!\n' +
        'Напишите пожалуйста Ваш номер телефона, я передам его в эту партнёрскую аптеку, и они Вам перезвонят, ответят на все вопросы и помогут с приобретением этого лекарства!',
      showArchive: false,
      drugsInfo: {},
      loading: false,
      sendLoading: false,
      messagesLoading: false,
      isLeftSidebarVisible: true,
      selectedChat: null,
      chatToDisplay: null,
      loadedImages: {},
      message: null,
      clientOrder: {drugs: []},
      chats: [],
      archiveCahts: [],
      selectedDate: moment().toDate(),
      archiveDateDisabledBefore: moment().add('-1', 'years').toDate(),
    }
  },
  watch: {
    'selectedCityId': {
      handler: function (val, oldVal) {
        this.$editNewOrder.city_id = +this.selectedCityId;
        this.$refs.newOrderBlock.$refs.ProjectCitySelect.city = +this.selectedCityId;
      },
      deep: true
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
    $AllProjects() {
      return this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        }, {});
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  beforeDestroy() {
    document.removeEventListener('selectionchange', this.onUpdatedSelectedText, false);
  },
  created() {
    document.addEventListener('selectionchange', this.onUpdatedSelectedText);
    this.getRecords();
    chatUpdated.$on("updateChat", async (data) => {
      console.log(data, this.selectedChat?.id, 'new');
      if (+data.chat_id === this.selectedChat?.id) {
        // console.log('open existing chat')
        this.openChat({...this.selectedChat}, true);
      } else {
        let index = this.chats.findIndex((c) => c.id === +data.chat_id);
        // console.log(index, 'try to refresh');
        if (index === -1) {
          // console.log('refresh records');
          await this.getRecords(true);
        }
        index = this.chats.findIndex((c) => c.id === +data.chat_id);
        this.chats[index].hasNewMessages = true;
      }
    });
  },
  methods: {
    async searchDataForDrug(drug) {
      // console.log(drug);
      this.drugForStoreData = null;
      await this.$nextTick();
      this.drugForStoreData = drug;
    },
    onUpdatedSelectedText() {
      const classes = window.getSelection().baseNode?.parentNode?.classList ?? [];
      // console.log(classes);
      if (!classes || !classes.length) return;
      if (!classes.contains('message_div')) return;
      const text = window.getSelection().toString();
      if (!text) return;
      if (text.length < 15) {
        const numbers = text.replace(/^\D+/g, '');
        if (numbers.length >= 7) {
          this.$refs.deliveryStatus.searchText = numbers;
          return;
        }
      }
      this.selectedText.value = text;
      if (text && text.length > 4) {
        this.drugForStoreData = null;
        this.$refs.searchDrug.drug = null;
        this.$refs.searchDrug.onSearchDrug(text, () => {
        });
      }
    },
    sortChats() {
      // console.log('sorting');
      // const chats = [...this.chats];
      // console.log(chats);
      // this.chats = [];
      // this.chats = _.orderBy(chats, 'fresh_message_id', 'DESC');
      // console.log(this.chats);
    },
    loadNewOrder(orderId) {
      this.selectedChat.order_id = null;
      setTimeout(() => {
        this.selectedChat.order_id = orderId;
      }, 200)
    },
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId})
    },
    getSortedOrders() {
      return _.orderBy(this.chatToDisplay.orders, 'id', 'desc')
    },
    updateSelectedDate(date) {
      // console.log(date);
      const newDate = moment(date).format('YYYY-MM-DD')
      this.selectedDate = newDate;
      this.getRecords(true);
    },
    async closeDialog() {
      this.sendLoading = true;
      const {data} = await api.post('/clientChats/chat/' + this.selectedChat.id, {
        action: 'closeDialog'
      });
      if (data.success) {
        this.chats = this.chats.filter((c) => c.id !== this.selectedChat.id);
        this.selectedChat = null;
        this.chatToDisplay = null;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.sendLoading = false;
    },
    createOffer() {
      return {
        order: {...this.$editNewOrder},
        client: this.$refs.newOrderBlock?.$refs?.clientData.client,
        phones: this.$refs.newOrderBlock?.$refs?.clientData.phones,
      }
    },
    async saveOffer() {
      const {data} = await api.post('/new/orders/createOrder', this.createOffer())
    },
    async sendMessage(type, selectedDrug = null) {
      let drug;
      let newOffer;
      if (type === 'message') {
        if (!this.message) {
          return;
        }
      }
      if (this.sendLoading) return;
      this.sendLoading = true;
      if (type === 'drug') {
        console.log(selectedDrug);
        if (!this.drugsInfo[selectedDrug.id]) {
          this.drugsInfo[selectedDrug.id] = {};
        }
        if (!this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id]) {
          const {data} = await api.post('/new/drugs/infoType', {
            types: ['projectInfo', 'siteDetails'],
            drug_id: selectedDrug.id,
            project_id: this.selectedChat.bot.project_id
          });
          if (data.success) {
            this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id] = data;
          } else {
            toastr['warning'](data.message || 'Ошибка получение данных о препарате');
            this.sendLoading = false;
            return;
          }
        }
        drug = {
          id: selectedDrug.id,
          title: selectedDrug.title,
          price: selectedDrug.actual_price * +selectedDrug.pack_set,
          pack_set: +selectedDrug.pack_set,
          prices: selectedDrug.prices.filter((p) => p.is_active && p.site_id === this.selectedChat.bot.project_id),
        };
        drug.link_origin = this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id].link;
        drug.link = this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id].link_share;
        drug.image = this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id].image_full || this.drugsInfo[selectedDrug.id][this.selectedChat.bot.project_id].image;
      }
      if (type === 'offer') {
        newOffer = this.createOffer();
      }
      const divId = this.$editNewOrder.division_id;
      console.log(divId);
      if (this.$AllDivisions[divId]?.settings?.currency_id) {
        drug.prices = drug.prices.map((p) => {
          return {
            ...p,
            price: Math.round(p.price * (this.$AllCurrencies[this.$AllDivisions[divId]?.settings?.cross_currency_id]?.rate ?? 1) / 50) * 50
          }
        });
      }
      try {
        const {data} = await api.post('/clientChats/message', {
          dialog_id: this.selectedChat.id,
          bot_id: this.selectedChat.bot_id,
          bot_platform: this.selectedChat.bot.platform,
          type,
          drug,
          newOffer,
          message: {
            text: this.message
          }
        });
        if (data.success) {
          this.message = null;
          await this.openChat(this.selectedChat, true);
          toastr['success']('Отправлено');
        } else {
          toastr['warning'](data.message || 'Ошибка');
        }
      } catch (e) {
        toastr['warning']('Ошибка отправки');
      }
      this.sendLoading = false;
    },
    async openChat(chat, silent = false) {
      this.drugForStoreData = null;
      this.selectedCityId = 1;
      const index = this.chats.findIndex((c) => c.id === +chat.id);
      if (index !== -1) {
        this.chats[index].hasNewMessages = false;
      }
      chat.hasNewMessages = false;
      if (!silent) {
        this.selectedChat = {...chat, locality: {project_id: chat.bot.project_id, city_id: 1}};
        this.messagesLoading = true;
        this.message = null;
        this.chatToDisplay = null;
      }
      const {data} = await api.index('/clientChats/chat/' + chat.id)
      if (data.success) {
        this.chatToDisplay = {...chat, ...data.record, messages: data.record.messages.reverse()};
        if (!silent) {
          setTimeout(() => {
            fillOrderBus.$emit(
              'updateFillOrder',
              {extra_data: {project_id: this.selectedChat.bot.project_id, city_id: 1}}
            );
          }, 300)
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.messagesLoading = false;
    },
    async getRecords(silent = false) {
      console.log(silent);
      const archive = this.showArchive;
      this.loading = true;
      if (!silent) {
        this.selectedChat = null;
        this.chatToDisplay = null;
      }
      const {data} = await api.index('/clientChats/list' + (archive ? '?d=' + this.selectedDate : ''))
      if (data.success) {
        if (archive) {
          this.archiveCahts = data.records;
        } else {
          this.chats = data.records.reduce((acc, r) => {
            acc.push({...r, hasNewMessages: false, sort_id: r.last_message?.id});
            return acc;
          }, []);
          // this.chats = _.orderBy(data.records.reduce((acc, r) => {
          //   acc.push({...r, hasNewMessages: false, sort_id: r.last_message?.id});
          //   return acc;
          // }, []), 'sort_id', 'desc');
        }
        if (this.$route.params?.chat_id) {
          const chat = this.chats.find((c) => c.id === +this.$route.params.chat_id);
          if (!silent) {
            this.openChat(chat);
          }
        }
        // this.sortChats();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>

<style>
.new_order_from_bot_block .main-content {
  padding: 0;
}
</style>

<style scoped>
.badge-telegram {
  color: white;
  background-color: #0088cc;
}

.badge-jivo {
  color: white;
  background-color: #2bac06;
}

.badge-viber {
  color: white;
  background-color: #59267c;
}

.badge-whatsapp {
  color: white;
  background-color: #128c7e;
}

.fs-10 {
  font-size: 10px;
}

.sidebar-menu li {
  position: relative;
}

.sidebar-menu .black_list_btn {
  position: absolute;
  top: 0;
  right: 0;
}

.sidebar-menu li:hover {
  background-color: #f8f8f8;
}

.sidebar-menu li {
  padding: 10px 15px;
}

.sidebar-menu p {
  margin-bottom: 2px;
}

p.text-muted {
  font-size: 14px;
}

a.left-sidebar-btn {
  text-decoration: none;
  background-color: #343A52 !important;
  color: white !important;
}

.messages_block {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid lightgray;
  height: 50vh;
  overflow: hidden;
  overflow-y: auto;
}

.drug_select_block {
  padding: 10px;
  border: 1px solid lightgray;
}

.ul_block {
  height: calc(100% - 95px);
  overflow-y: auto;
}

.btns_block button {
  margin-right: 3px;
}

.mailbox {
  min-height: 740px;
  //min-height: 500px;
}

.mailbox .mailbox-sidebar .left-sidebar-btn {
  position: fixed;
  top: 350px;
}
</style>
